module.exports = __webpack_public_path__ + "assets/0e0690662255afa376cf8cfba3601ad6.mp3";